export default async function login (socket, token) {
  const user = await socket.service('auth_token/USE', { token })
  socket.auth.setUser(user)
  await socket.auth.renewToken()
}
